export const JsonOptionsType = [
    {value: 'text', label: 'Текст'},
    {value: 'textarea', label: 'Большой текст'},
    {value: 'number', label: 'Цифры'},
    {value: 'radio', label: 'Выбор'},
    {value: 'checkboxes', label: 'Множественный выбор'},
]